import Aos from 'aos';
import ImageCompare from 'image-compare-viewer';
import fslightbox from 'fslightbox';

window.Aos = Aos;
window.ImageCompare = ImageCompare;

import AppInit from './component/AppInit';

import BtnProgress from './component/BtnProgress';
import BtnCheck from './component/BtnCheck';
import Animation from './component/Animation';
import { Form } from './component/Form';
import FlashMessage from './component/FlashMessage';
import ToggleShow from './component/ToggleShow';
import Tabs from './component/Tabs';
import ThemeSwitcher from './component/ThemeSwitcher';
import GridAnimation from './component/GridAnimation';
import Navbar from './component/Navbar';
import NetteForms from 'nette-forms';
import TimelineExpand from './component/TimelineExpand';
import CaseStudyTimeline from './component/CaseStudyTimeline';
import FormLogoAnimation from './component/FormLogoAnimation';
import AboutAnimation from './component/AboutAnimation';
import ReactSectionAnimation from './component/ReactSectionAnimation';
import LogoAnimation from './component/LogoAnimation';
import SplideInit from './component/SplideInit';
import Faq from './component/Faq';
import CopyText from './component/CopyText';
import WebReference from './component/WebReference';
import CmsAnimation from './component/CmsAnimation';
import TextImgAnchor from './component/TextImgAnchor';
import Anchor from './component/Anchor';
import SolutionSection from './component/SolutionSection';
import YearToday from './component/YearToday';
import HeaderAnimation from './component/HeaderAnimation';
import ScrollTopButton from './component/ScrollTopButton';
import TooltipFunction from './component/TooltipFunction';
import HeaderSlider from './component/HeaderSlider';
import TechnologyStack from './component/TechnologyStack';
import UrlScroll from './component/UrlScroll';
import Modal from './component/Modal';
import VideoNav from './component/VideoNav';

import "./custom/cookieconsent-init";
import "./custom/custom";
import "./custom/recaptchaV3";

document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));
NetteForms.initOnLoad();
(<any>window).nette = NetteForms;

AppInit.onInit(() => {
    HeaderAnimation.init();
    BtnProgress.init();
    BtnCheck.init();
    Animation.init();
    Form.init();
    FlashMessage.init();
    ToggleShow.init();
    Tabs.init();
    ThemeSwitcher.init();
    GridAnimation.init();
    TimelineExpand.init();
    CaseStudyTimeline.init();
    FormLogoAnimation.init();
    AboutAnimation.init();
    ReactSectionAnimation.init();
    //LogoAnimation.init();
    Navbar.init();
    SplideInit.init();
    Faq.init();
    CopyText.init();
    WebReference.init();
    CmsAnimation.init();
    TextImgAnchor.init();
    Anchor.init();
    SolutionSection.init();
    YearToday.init();
    ScrollTopButton.init();
    TooltipFunction.init();
    HeaderSlider.init();
    TechnologyStack.init();
    UrlScroll.init();
    Modal.init();
    VideoNav.init();
});

AppInit.init();

window.addEventListener('scroll', () => {
    Animation.init();
});
